import { SchoolSharp, WorkOutlined } from '@mui/icons-material';
import { MdOutlineWeb, MdAutoGraph } from 'react-icons/md';
import { TimelineContent, TimelineDot, TimelineItem } from '@mui/lab';
import { Grid, Icon, Paper, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import CustomProjectTimelineItem from '../../components/CustomProjectTimelineItem/CustomProjectTimelineItem';
import CustomTimeline, { CustomTimelineSeparator } from '../../components/Timeline/CustomTimeline';
import useData from '../../Hooks/useData';
import CodeIcon from '@mui/icons-material/Code';
import './Resume.css'
import { Box } from '@mui/system';

const Resume = () => {
    const { aboutMe, edu, skills, projects } = useData()
    useEffect(() => {
        const prevTitle = document.title;
        document.title = "Resume";
        return () => {
            document.title = prevTitle;
        };
    });
    const serviceIcon =
        [
            {
                id: "01",
                icons: <CodeIcon />,
                title: "Web Development",
                desc: "I have a been a badass web developer for 10 years"
            },
            {
                id: "02",
                icons: <MdAutoGraph />,
                title: "Web Development",
                desc: "I have a been a badass web developer for 10 years"
            },
            {
                id: "03",
                icons: <MdOutlineWeb />,
                title: "Web Development",
                desc: "I have a been a badass web developer for 10 years"
            }
        ]
    return (
        <>
            {/* About me  */}
            <Grid container className="section mb-4">
                <TitleSection text={"About me"} />
                <Grid item xs={12}>
                    <Typography className="aboutme-text">{aboutMe}</Typography>
                </Grid>
            </Grid>


            {/* education and experiences  */}
            <Grid container className="section mb-4">
                <TitleSection text={"Resume"} />
                <Grid item xs={12}>
                    <Grid container>

                        {/* Projects  */}
                        <Grid item md={6}>
                            <CustomTimeline
                                title={"Projects"}
                                icon={<WorkOutlined />}
                            >
                                {projects?.map(p => <CustomProjectTimelineItem key={p.id} p={p} />)}
                            </CustomTimeline>
                        </Grid>

                        {/* Educations  */}
                        <Grid item md={6}>
                            <CustomTimeline
                                title={"Education"}
                                icon={<SchoolSharp />}
                            >
                                {edu?.map(e => <CustomEducationTimelineItem key={e.id} e={e} />)}
                            </CustomTimeline>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>


            {/* My service section  */}
            <Grid container className="section mb-4">
                <TitleSection text={"What I'm Doing"} />
                <Grid item xs={12}>
                    <Grid container spacing={1} justifyContent="space-around">
                        {
                            serviceIcon?.map((s) => (

                                <Grid key={s.id} item xs={12} sm={6} md={4}>
                                    <div className="service px-2 py-3">
                                        <Icon className="">{s.icons}</Icon>
                                        <Typography className="service-title mb-2" variant="h6">{s.title}</Typography>
                                        <Typography className="service-orgName" variant="body2">{s.desc}</Typography>
                                    </div>
                                </Grid>
                            ))}
                    </Grid>
                </Grid>
            </Grid>
            {/* End my service section  */}

            {/* Skill Section */}
            <TitleSection text={"Skills"} />
            <Grid container sx={{ py: 4 }}>
                <Grid item xs={12}>
                    <Grid container spacing={2} justifyContent="space-between">
                        {skills?.map(skill => (
                            <Grid item xs={12} sm={6} md={3}>
                                <Paper className="skill" elevation={0}>
                                    <Typography variant="h4" className="skill-title">
                                        {skill.title}
                                    </Typography>
                                    {skill?.desc?.map(topic => (


                                        <Box sx={{ display: "flex", alignItems: "center" }}>

                                            <TimelineDot variant="outlined" color="primary" />


                                            <TimelineContent variant="body2">{topic}</TimelineContent>
                                        </Box>


                                    ))}


                                </Paper>
                            </Grid>
                        ))
                        }
                    </Grid>
                </Grid>

            </Grid>
            {/* end Skill Section  */}




        </>
    );
};
const CustomEducationTimelineItem = ({ e }) => {
    const { title, date, orgName, gpa } = e
    return (
        <TimelineItem>
            <CustomTimelineSeparator />
            <TimelineContent >
                <Typography className="fw-bold fs-6">{title}</Typography>
                <Typography variant="caption" className="timeline-date">{date}</Typography> <br />
                <Typography variant="caption" >{gpa}</Typography>
                <Typography variant="subtitle2" className="timeline-orgNameription">{orgName}</Typography>

            </TimelineContent>
        </TimelineItem>
    )
}

export const TitleSection = ({ text }) => {
    return (
        <Grid item className="section-title my-3 my-md-4">
            <span></span>
            <h6 className="section-title-text">{text}</h6>
        </Grid>
    )
}
export default Resume;